export default __webpack_public_path__ + "static/media/regulatory--bus-priority-lane--g1.2ae10a51.png";